export default __webpack_public_path__ + "images/c602c4a14a06991fc3c5d640524175d9.png";